import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Pill, DrawerHeader, Drawer, DrawerBody,
} from '@one-thd/sui-atomic-components';
import { CustomOptions } from '@one-thd/sui-icons';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { extend, QueryProvider } from '@thd-nucleus/data-sources';
import { DynamicRecsWrapper, ZoneCard } from '@thd-olt-component-react/thd-recs-containers';

const ViewSimilarIcon = ({
  itemId,
  products,
  storeId
}) => {
  const selectedItemProduct = React.useMemo(
    () => (
      Array.isArray(products)
        ? products.filter((product) => product.itemId === itemId)
        : []
    ),
    [products, itemId]
  );

  const { defaultVariables } = useContext(ExperienceContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
    window.LIFE_CYCLE_EVENT_BUS.trigger('view-similar.morelikethisoverlay');
  };
  const handleClose = () => setOpen(false);
  const ctxDefaultVariables = {
    itemId,
    storeId,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <>
      <Pill
        label="View Similar"
        onClick={handleOpen}
        icon={<CustomOptions />}
        style={{ fontSize: '14px' }}
      />
      {open && (
        <QueryProvider defaultVariables={ctxDefaultVariables} cacheKey="cart-instock-recs">
          <Drawer open={open} onClose={handleClose} position="right">
            <DrawerHeader title="Similar Items" onClose={handleClose} />
            <DrawerBody name="recommendations-cart-instock">
              <DynamicRecsWrapper
                schemaName="more_like_this"
                anchorId={itemId}
                selectedItemProduct={selectedItemProduct}
                errorBoundary
                requestKey="aGAQFG4j6QtVTSWqujfFYWeIU6BR5Mee"
                maxResults={18}
                isMoreLikeThis
                hydrator={{
                  className: 'grid',
                  tag: ZoneCard,
                  id: `more_like_this-${itemId}`,
                  scrollBuffer: 0,
                  delay: 200
                }}
              />
            </DrawerBody>
          </Drawer>
        </QueryProvider>
      )}
    </>

  );
};

ViewSimilarIcon.propTypes = {
  itemId: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  storeId: PropTypes.string
};

ViewSimilarIcon.defaultProps = {
  products: [],
  storeId: ''

};

ViewSimilarIcon.dataModel = extend(
  DynamicRecsWrapper
);
ViewSimilarIcon.displayName = 'ViewSimilarIcon';

export { ViewSimilarIcon };
